var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));

// index.ts
import {
  createRenderer
} from "@vue/runtime-core";

// patch-prop.ts
import {callWithAsyncErrorHandling} from "@vue/runtime-core";
import {isOn} from "@vue/shared";

// runtime/config/index.ts
var IS_PROD = __IS_PRODUCTION__;
var NATIVE_COMPONENT_MAP = {
  view: "view",
  image: "image",
  text: "text",
  scrollview: "scroll-view",
  qlPlayer: "ql-player",
  qlChannelPlayer: "ql-channel-player",
  ul: "ul",
  li: "li",
  input: "input",
  textarea: "textarea",
  richtext2: "richtext2",
  qlWebView2: "ql-web-view2",
  qlWebView: "ql-webview",
  qlImage: "ql-image",
  vFrame: "v-frame",
  cell: "cell",
  gridlist: "grid-list",
  qlWebview: "ql-webview"
};

// utils/index.ts
function trace(...context) {
  if (IS_PROD === true) {
    return;
  }
  console.log(...context);
}
var DEFAULT_ROOT_ID = 0;
var uniqueId = DEFAULT_ROOT_ID;
function getUniqueId() {
  uniqueId += 1;
  if (uniqueId % 10 === 0) {
    uniqueId += 1;
  }
  return uniqueId;
}
function normalizeTagName(tagName) {
  return tagName.toLowerCase();
}
function warn(...context) {
  console.warn(...context);
}
function parseRemStyle(styleValue) {
  let value = styleValue;
  if (typeof value !== "string" || !value.endsWith("rem")) {
    return value;
  }
  value = parseFloat(value);
  if (Number.isNaN(value)) {
    return styleValue;
  }
  return value;
}
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function deepCopy(data, hash = new WeakMap()) {
  if (typeof data !== "object" || data === null) {
    throw new TypeError("deepCopy data is object");
  }
  if (hash.has(data)) {
    return hash.get(data);
  }
  const newData = {};
  const dataKeys = Object.keys(data);
  dataKeys.forEach((value) => {
    const currentDataValue = data[value];
    if (typeof currentDataValue !== "object" || currentDataValue === null) {
      newData[value] = currentDataValue;
    } else if (Array.isArray(currentDataValue)) {
      newData[value] = [...currentDataValue];
    } else if (currentDataValue instanceof Set) {
      newData[value] = new Set([...currentDataValue]);
    } else if (currentDataValue instanceof Map) {
      newData[value] = new Map([...currentDataValue]);
    } else {
      hash.set(data, data);
      newData[value] = deepCopy(currentDataValue, hash);
    }
  });
  return newData;
}
function setsAreEqual(leftSet, rightSet) {
  if (leftSet.size !== rightSet.size) {
    return false;
  }
  const values = leftSet.values();
  let leftValue = values.next().value;
  while (leftValue) {
    if (!rightSet.has(leftValue)) {
      return false;
    }
    leftValue = values.next().value;
  }
  return true;
}
function mapEVOEvent(generalEventParams, rawNativeEventName) {
  const map = new Map();
  if (Array.isArray(generalEventParams)) {
    generalEventParams.forEach(([vueEventName, nativeEventName]) => {
      map.set(vueEventName, nativeEventName);
      map.set(nativeEventName, vueEventName);
    });
  } else {
    map.set(generalEventParams, rawNativeEventName);
    map.set(rawNativeEventName, generalEventParams);
  }
  return map;
}
function getViewId(target) {
  return parseInt(target["__viewId__"]);
}
function lowerFirstLetter(str) {
  return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
}

// transfer-style.ts
var rgbaToHex = (rgba) => {
  const regex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/;
  const matches = regex.exec(rgba);
  if (!matches) {
    throw new Error("Invalid RGBA/RGB string");
  }
  const r = parseInt(matches[1], 10);
  const g = parseInt(matches[2], 10);
  const b = parseInt(matches[3], 10);
  const a2 = matches[4] ? parseFloat(matches[4]) : 1;
  const hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  const alpha = Math.round(a2 * 255).toString(16).padStart(2, "0");
  return `#${hex}${alpha}`;
};
var transferStyle = (styleAttr, styleAttrVal) => {
  if (styleAttr === "object-fit") {
    switch (styleAttrVal) {
      case "fill":
        return [{
          key: "mode",
          val: "fit-xy"
        }];
      case "contain":
        return [{
          key: "mode",
          val: "fit-center"
        }];
      case "cover":
        return [{
          key: "mode",
          val: "center-crop"
        }];
      default:
        break;
    }
  }
  if (styleAttr === "border") {
    const valueList = styleAttrVal.split(" ");
    if (valueList.length === 3) {
      return [
        {
          key: "border-width",
          val: valueList[0]
        },
        {
          key: "border-style",
          val: valueList[1]
        },
        {
          key: "border-color",
          val: valueList[2]
        }
      ];
    }
  }
  if (styleAttr === "cursor" && styleAttrVal === "pointer") {
    return [
      {
        key: "cursor",
        val: "hand"
      }
    ];
  }
  if (styleAttr === "color" || styleAttr === "background-color") {
    if (styleAttrVal == null ? void 0 : styleAttrVal.startsWith("rgb")) {
      return [{
        key: styleAttr,
        val: rgbaToHex(styleAttrVal)
      }];
    }
    if (/^#(?:[0-9a-fA-F]{6})$/.test(styleAttrVal)) {
      return [{
        key: styleAttr,
        val: `${styleAttrVal}FF`
      }];
    }
  }
  if (styleAttr === "z-index") {
    let zIndex = parseInt(styleAttrVal);
    zIndex = -zIndex + 10;
    return [
      {
        key: "z-order",
        val: String(zIndex)
      }
    ];
  }
  return [];
};

// patch-prop.ts
function setAttributeInternal(el, key, value) {
  if (key === "display" && value === "block") {
    el.setAttribute("flex-direction", "column");
    el.setAttribute("align-items", "stretch");
  }
  el.setAttribute(key, value);
}
function patchAttr(el, key, prevValue, nextValue) {
  if (nextValue === null) {
    el.removeAttribute(key);
  } else if (prevValue !== nextValue) {
    setAttributeInternal(el, key, nextValue);
  }
}
function patchClass(el, newValue) {
  let value = newValue;
  if (value === null) {
    value = "";
  }
  const transitionClasses = "";
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  el.setAttribute("class", value);
}
function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function patchStyleInEVO(el, prev, next) {
  trace(el, prev, next);
  if (next) {
    const styleObj = next;
    Object.keys(styleObj).forEach((styleKey) => {
      const standKey = camelToKebab(styleKey);
      const transResList = transferStyle(standKey, styleObj[styleKey]);
      if (transResList.length > 0) {
        transResList.forEach((item) => {
          el.setAttribute(item.key, item.val);
        });
      } else {
        setAttributeInternal(el, standKey, styleObj[styleKey]);
      }
    });
  }
}
var optionsModifierRE = /(?:Once|Passive|Capture|Signal)$/;
function parseName(eventName) {
  let name = eventName;
  const options = {};
  if (optionsModifierRE.test(name)) {
    let match = name.match(optionsModifierRE);
    while (match) {
      name = name.slice(0, name.length - match[0].length);
      options[match[0].toLowerCase()] = true;
      match = name.match(optionsModifierRE);
    }
  }
  name = name[2] === ":" ? name.slice(3) : name.slice(2);
  return [lowerFirstLetter(name), options];
}
function createInvoker(initialValue, instance) {
  const invoker = (e) => callWithAsyncErrorHandling(invoker.value, instance, 5, [e]);
  invoker.value = initialValue;
  return invoker;
}
function patchEvent(rawEl, rawName, prevValue, nextValue, instance = null) {
  var _a;
  const el = rawEl;
  const invokers = (_a = el._vei) != null ? _a : el._vei = {};
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name, options] = parseName(rawName);
    if (nextValue) {
      invokers[rawName] = createInvoker(nextValue, instance);
      const invoker = invokers[rawName];
      el.addEventListener(name, invoker, options);
    } else {
      el.removeEventListener(name, existingInvoker, options);
      invokers[rawName] = void 0;
    }
    const specialEventName = ["resize", "attached", "detached", "bindattached", "binddetached"];
    if (specialEventName.includes(name)) {
      el.setAttribute(name, nextValue ? "true" : "false");
    }
  }
}
function patchProp(el, key, prevValue, nextValue, isSVG, prevChildren, parentComponent) {
  switch (key) {
    case "class":
      patchClass(el, nextValue);
      break;
    case "style":
      patchStyleInEVO(el, prevValue, nextValue);
      break;
    default:
      if (isOn(key)) {
        patchEvent(el, key, prevValue, nextValue, parentComponent);
      } else {
        patchAttr(el, key, prevValue, nextValue);
      }
      break;
  }
}

// utils/instance.ts
var EVOCachedInstance;
function getEVOCachedInstance() {
  return EVOCachedInstance;
}
function setEVOCachedInstance(instance) {
  EVOCachedInstance = instance;
}

// runtime/element/evo-element.ts
import {toRaw} from "@vue/runtime-core";
import {isFunction, isString} from "@vue/shared";

// utils/event.ts
var EventMethod = {
  ADD: "addEventListener",
  REMOVE: "removeEventListener"
};

// runtime/component/index.ts
var tagMap = new Map();
function registerElement(tagName, elementComponent) {
  if (!tagName) {
    throw new Error("tagName can not be empty");
  }
  const normalizedTagName = normalizeTagName(tagName);
  if (!tagMap.has(normalizedTagName)) {
    tagMap.set(normalizedTagName, elementComponent.component);
  }
}
function getTagComponent(tagName) {
  const normalizedTagName = normalizeTagName(tagName);
  return tagMap.get(normalizedTagName);
}

// utils/node-cache.ts
var nodeCache = new Map();
function preCacheNode(targetNode, nodeId) {
  nodeCache.set(nodeId, targetNode);
}
function unCacheNode(nodeId) {
  nodeCache.delete(nodeId);
}
function getNodeById(nodeId) {
  return nodeCache.get(nodeId) || null;
}
function recursivelyUnCacheNode(node) {
  var _a;
  if (typeof node === "number") {
    unCacheNode(node);
  } else if (node) {
    unCacheNode(node.nodeId);
    (_a = node.childNodes) == null ? void 0 : _a.forEach((childNode) => recursivelyUnCacheNode(childNode));
  }
}
function requestIdleCallback(cb, options) {
  if (!global.requestIdleCallback) {
    return setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining() {
          return Infinity;
        }
      });
    }, 1);
  }
  return global.requestIdleCallback(cb, options);
}
function unCacheNodeOnIdle(node) {
  requestIdleCallback((deadline) => {
    if (deadline.timeRemaining() > 0 || deadline.didTimeout) {
      recursivelyUnCacheNode(node);
    }
  }, {timeout: 50});
}

// runtime/event/evo-event-target.ts
import {looseEqual} from "@vue/shared";
var EVOEventTarget = class {
  constructor() {
    this.listeners = {};
  }
  static indexOfListener(list, callback, options) {
    return list.findIndex((entry) => {
      if (options) {
        return entry.callback === callback && looseEqual(entry.options, options);
      }
      return entry.callback === callback;
    });
  }
  addEventListener(type, callback, options) {
    const events = type.split(",");
    const len = events.length;
    for (let i2 = 0; i2 < len; i2 += 1) {
      const eventName = events[i2].trim();
      const existEventList = this.listeners[eventName];
      const eventList = existEventList != null ? existEventList : [];
      eventList.push({
        callback,
        options
      });
      this.listeners[eventName] = eventList;
    }
  }
  removeEventListener(type, callback, options) {
    const events = type.split(",");
    const len = events.length;
    for (let i2 = 0; i2 < len; i2 += 1) {
      const eventName = events[i2].trim();
      if (callback) {
        if (this.listeners[eventName]) {
          const list = this.listeners[eventName];
          if (list == null ? void 0 : list.length) {
            const index = EVOEventTarget.indexOfListener(list, callback, options);
            if (index >= 0) {
              list.splice(index, 1);
            }
            if (!list.length) {
              this.listeners[eventName] = void 0;
            }
          }
        }
      } else {
        this.listeners[eventName] = void 0;
      }
    }
  }
  emitCaptureEvent(event) {
    var _a;
    const {type: eventName} = event;
    const listeners = this.listeners[eventName];
    if (!listeners) {
      return;
    }
    const ret = [];
    for (let i2 = listeners.length - 1; i2 >= 0; i2 -= 1) {
      const listener = listeners[i2];
      if ((_a = listener.options) == null ? void 0 : _a.capture) {
        ret.push(listener.callback.apply(listener.options.thisArg, [event]));
      }
    }
    if (ret.length === 0) {
      return void 0;
    }
    return ret[0];
  }
  emitEvent(event) {
    var _a, _b, _c;
    const {type: eventName} = event;
    const listeners = this.listeners[eventName];
    if (!listeners) {
      return;
    }
    const ret = [];
    for (let i2 = listeners.length - 1; i2 >= 0; i2 -= 1) {
      const listener = listeners[i2];
      if ((_a = listener.options) == null ? void 0 : _a.capture) {
        continue;
      }
      if ((_b = listener.options) == null ? void 0 : _b.once) {
        listeners.splice(i2, 1);
      }
      if ((_c = listener.options) == null ? void 0 : _c.thisArg) {
        ret.push(listener.callback.apply(listener.options.thisArg, [event]));
      } else {
        ret.push(listener.callback(event));
      }
    }
    if (ret.length === 0) {
      return void 0;
    }
    return ret[0];
  }
  getEventListenerList() {
    return this.listeners;
  }
};

// runtime/render/index.ts
import {nextTick} from "@vue/runtime-core";
var NodeOperateType;
(function(NodeOperateType2) {
  NodeOperateType2[NodeOperateType2["CREATE"] = 0] = "CREATE";
  NodeOperateType2[NodeOperateType2["UPDATE"] = 1] = "UPDATE";
  NodeOperateType2[NodeOperateType2["DELETE"] = 2] = "DELETE";
})(NodeOperateType || (NodeOperateType = {}));
var isHandling = false;
var batchNativeNodes = [];
var componentName = ["%c[native]%c", "color: red", "color: auto"];
function chunkNodes(batchNodes) {
  const result = [];
  for (const batchNode of batchNodes) {
    const {type, nodes} = batchNode;
    const chunk = result[result.length - 1];
    if (!chunk || chunk.type !== type) {
      result.push({
        type,
        nodes
      });
    } else {
      chunk.nodes = chunk.nodes.concat(nodes);
    }
  }
  return result;
}
function renderToNativeImmediate() {
  const chunks = chunkNodes(batchNativeNodes);
  const {vnContext: vnContext2} = getEVOCachedInstance();
  chunks.forEach((chunk) => {
    switch (chunk.type) {
      case 0:
        trace(...componentName, "createNode", chunk.nodes);
        vnContext2.page.createNode(chunk.nodes);
        break;
      case 1:
        trace(...componentName, "updateNode", chunk.nodes);
        vnContext2.page.updateNode(chunk.nodes);
        break;
      case 2:
        trace(...componentName, "deleteNode", chunk.nodes);
        vnContext2.page.deleteNode(chunk.nodes);
        break;
      default:
        break;
    }
  });
  vnContext2.page.endBatch();
  isHandling = false;
  batchNativeNodes = [];
}
function renderToNative(nativeNodes, operateType) {
  batchNativeNodes.push({
    type: operateType,
    nodes: nativeNodes
  });
  if (isHandling) {
    return;
  }
  isHandling = true;
  if (batchNativeNodes.length === 0) {
    isHandling = false;
    return;
  }
  getEVOCachedInstance().vnContext.page.startBatch();
  nextTick().then(() => {
    renderToNativeImmediate();
  });
}
function renderInsertChildNativeNode(nativeNodes) {
  renderToNative(nativeNodes, 0);
}
function renderRemoveChildNativeNode(deleteNodes) {
  renderToNative(deleteNodes, 2);
}
function renderUpdateChildNativeNode(updateNodes) {
  renderToNative(updateNodes, 1);
}

// runtime/node/node.ts
var NodeType;
(function(NodeType2) {
  NodeType2[NodeType2["ElementNode"] = 1] = "ElementNode";
  NodeType2[NodeType2["TextNode"] = 2] = "TextNode";
  NodeType2[NodeType2["CommentNode"] = 3] = "CommentNode";
  NodeType2[NodeType2["DocumentNode"] = 4] = "DocumentNode";
})(NodeType || (NodeType = {}));
function needInsertToNative(nodeType) {
  return nodeType === 1;
}
var EVONode = class extends EVOEventTarget {
  constructor(nodeType) {
    super();
    this.isMounted = false;
    this.childNodes = [];
    this.parentNode = null;
    this.prevSibling = null;
    this.nextSibling = null;
    this.tagComponent = null;
    this.nodeId = EVONode.getUniqueNodeId();
    this.nodeType = nodeType;
    this.isNeedInsertToNative = needInsertToNative(nodeType);
  }
  static getUniqueNodeId() {
    return getUniqueId();
  }
  get firstChild() {
    return this.childNodes.length ? this.childNodes[0] : null;
  }
  get lastChild() {
    const len = this.childNodes.length;
    return len ? this.childNodes[len - 1] : null;
  }
  get component() {
    return this.tagComponent;
  }
  get index() {
    let index = 0;
    if (this.parentNode) {
      const needInsertToNativeChildNodes = this.parentNode.childNodes.filter((node) => node.isNeedInsertToNative);
      index = needInsertToNativeChildNodes.indexOf(this);
    }
    return index;
  }
  isRootNode() {
    return this.nodeId === DEFAULT_ROOT_ID;
  }
  insertBefore(rawChild, rawAnchor) {
    const child = rawChild;
    const anchor = rawAnchor;
    if (!child) {
      throw new Error("No child to insert");
    }
    if (!anchor) {
      this.appendChild(child);
      return;
    }
    if (child.parentNode !== null && child.parentNode !== this) {
      throw new Error("Can not insert child, because the child node is already has a different parent");
    }
    let parentNode2 = this;
    if (anchor.parentNode !== this) {
      parentNode2 = anchor.parentNode;
    }
    const index = parentNode2.childNodes.indexOf(anchor);
    child.parentNode = parentNode2;
    child.nextSibling = anchor;
    child.prevSibling = parentNode2.childNodes[index - 1];
    if (parentNode2.childNodes[index - 1]) {
      parentNode2.childNodes[index - 1].nextSibling = child;
    }
    anchor.prevSibling = child;
    parentNode2.childNodes.splice(index, 0, child);
    this.insertChildNativeNode(child);
  }
  moveChild(rawChild, rawAnchor) {
    const child = rawChild;
    const anchor = rawAnchor;
    if (!child) {
      throw new Error("No child to move");
    }
    if (!anchor) {
      this.appendChild(child);
      return;
    }
    if (anchor.parentNode && anchor.parentNode !== this) {
      throw new Error("Can not move child, because the anchor node is already has a different parent");
    }
    if (child.parentNode && child.parentNode !== this) {
      throw new Error("Can't move child, because it already has a different parent");
    }
    const oldIndex = this.childNodes.indexOf(child);
    const anchorIndex = this.childNodes.indexOf(anchor);
    if (anchorIndex === oldIndex) {
      return;
    }
    child.nextSibling = anchor;
    child.prevSibling = anchor.prevSibling;
    anchor.prevSibling = child;
    if (this.childNodes[anchorIndex - 1]) {
      this.childNodes[anchorIndex - 1].nextSibling = child;
    }
    if (this.childNodes[anchorIndex + 1]) {
      this.childNodes[anchorIndex + 1].prevSibling = child;
    }
    if (this.childNodes[oldIndex - 1]) {
      this.childNodes[oldIndex - 1].nextSibling = this.childNodes[oldIndex + 1];
    }
    if (this.childNodes[oldIndex + 1]) {
      this.childNodes[oldIndex + 1].prevSibling = this.childNodes[oldIndex - 1];
    }
    this.childNodes.splice(oldIndex, 1);
    this.removeChildNativeNode(child);
    const newIndex = this.childNodes.indexOf(anchor);
    this.childNodes.splice(newIndex, 0, child);
    this.insertChildNativeNode(child);
  }
  appendChild(rawChild) {
    const child = rawChild;
    if (!child) {
      throw new Error("No child to append");
    }
    if (this.lastChild === child)
      return;
    if (child.parentNode && child.parentNode !== this) {
      child.parentNode.removeChild(child);
    }
    if (child.isMounted) {
      this.removeChild(child);
    }
    child.parentNode = this;
    if (this.lastChild) {
      child.prevSibling = this.lastChild;
      this.lastChild.nextSibling = child;
    }
    this.childNodes.push(child);
    this.insertChildNativeNode(child);
  }
  removeChild(rawChild) {
    const child = rawChild;
    if (!child) {
      throw new Error("Can't remove child.");
    }
    if (!child.parentNode) {
      throw new Error("Can't remove child, because it has no parent.");
    }
    if (child.parentNode !== this) {
      child.parentNode.removeChild(child);
      return;
    }
    if (!child.isNeedInsertToNative) {
      return;
    }
    if (child.prevSibling) {
      child.prevSibling.nextSibling = child.nextSibling;
    }
    if (child.nextSibling) {
      child.nextSibling.prevSibling = child.prevSibling;
    }
    child.prevSibling = null;
    child.nextSibling = null;
    const index = this.childNodes.indexOf(child);
    this.childNodes.splice(index, 1);
    this.removeChildNativeNode(child);
  }
  findChild(condition) {
    const yes = condition(this);
    if (yes) {
      return this;
    }
    if (this.childNodes.length) {
      for (const childNode of this.childNodes) {
        const targetChild = this.findChild.call(childNode, condition);
        if (targetChild) {
          return targetChild;
        }
      }
    }
    return null;
  }
  eachNode(callback) {
    if (callback) {
      callback(this);
    }
    if (this.childNodes.length) {
      this.childNodes.forEach((child) => {
        this.eachNode.call(child, callback);
      });
    }
  }
  insertChildNativeNode(child) {
    if (!child.isNeedInsertToNative)
      return;
    const renderRootNodeCondition = this.isRootNode() && !this.isMounted;
    const renderOtherNodeCondition = this.isMounted && !child.isMounted;
    if (renderRootNodeCondition || renderOtherNodeCondition) {
      const parentNode2 = renderRootNodeCondition ? this : child;
      const nodeList = parentNode2.convertToNativeNodes(true);
      parentNode2.eachNode((rawNode) => {
        const node = rawNode;
        if (!node.isMounted && node.isNeedInsertToNative) {
          node.isMounted = true;
        }
        preCacheNode(node, node.nodeId);
      });
      renderInsertChildNativeNode(nodeList);
    }
  }
  removeChildNativeNode(child) {
    const toRemoveNode = child;
    if (toRemoveNode.isMounted) {
      toRemoveNode.isMounted = false;
      renderRemoveChildNativeNode(toRemoveNode.convertToNativeNodes(false));
    }
  }
  updateNativeNode(isIncludeChildren = false) {
    if (!this.isMounted) {
      return;
    }
    const updateNodes = this.convertToNativeNodes(isIncludeChildren);
    renderUpdateChildNativeNode(updateNodes);
  }
  convertToNativeNodes(isIncludeChild, extraAttributes) {
    var _a, _b;
    if (!this.isNeedInsertToNative) {
      return [];
    }
    if (isIncludeChild) {
      const nativeNodes = [];
      this.eachNode((targetNode) => {
        const nativeChildNodes = targetNode.convertToNativeNodes(false);
        if (nativeChildNodes.length) {
          nativeNodes.push(...nativeChildNodes);
        }
      });
      return nativeNodes;
    }
    if (!this.component) {
      throw new Error("tagName is not supported yet");
    }
    const {rootViewId} = getEVOCachedInstance();
    const attributes = extraAttributes != null ? extraAttributes : {};
    return [
      __spreadValues({
        id: this.nodeId,
        parentId: (_b = (_a = this.parentNode) == null ? void 0 : _a.nodeId) != null ? _b : rootViewId,
        index: this.index
      }, attributes)
    ];
  }
};

// runtime/element/evo-element.ts
function parseTextShadowOffset(property, value = 0, rawStyle) {
  var _a;
  const style = rawStyle;
  const offsetMap = {
    textShadowOffsetX: "width",
    textShadowOffsetY: "height"
  };
  style.textShadowOffset = (_a = style.textShadowOffset) != null ? _a : {};
  Object.assign(style.textShadowOffset, {
    [offsetMap[property]]: value
  });
  return ["textShadowOffset", style.textShadowOffset];
}
var NATIVE_COMPONENT_MAP2 = {
  View: "View",
  Image: "Image",
  ListView: "ListView",
  ListViewItem: "ListViewItem",
  Text: "Text",
  TextInput: "TextInput",
  WebView: "WebView",
  ScrollView: "ScrollView"
};
function parseViewComponent(node, rawNativeNode, rawStyle) {
  const nativeNode = rawNativeNode;
  const style = rawStyle;
  if (node.component.name === "view") {
    trace("node----->", node);
    if (node.attributes["overflow-y"] === "scroll") {
      nativeNode.name = "scroll-view";
      nativeNode.props.direction = "column";
    }
    if (node.attributes["overflow-x"] === "scroll") {
      nativeNode.name = "scroll-view";
      nativeNode.props.direction = "row";
    }
  }
  if (node.component.name === NATIVE_COMPONENT_MAP2.View) {
    if (style.overflowX === "scroll" && style.overflowY === "scroll") {
      warn("overflow-x and overflow-y for View can not work together");
    }
    if (style.overflowY === "scroll") {
      nativeNode.name = "ScrollView";
    } else if (style.overflowX === "scroll") {
      nativeNode.name = "ScrollView";
      if (nativeNode.props) {
        nativeNode.props.horizontal = true;
      }
    }
    if (nativeNode.name === "ScrollView") {
      if (node.childNodes.length !== 1) {
        warn("Only one child node is acceptable for View with overflow");
      }
      if (node.childNodes.length && node.nodeType === NodeType.ElementNode) {
        node.childNodes[0].setStyle("collapsable", false);
      }
    }
    if (style.backgroundImage) {
    }
  }
}
var EVOElement = class extends EVONode {
  constructor(tagName) {
    super(NodeType.ElementNode);
    this.id = "";
    this.scopedIdList = [];
    this.beforeLoadStyle = (val) => val;
    this.tagName = tagName.toLowerCase();
    this.classList = new Set();
    this.attributes = {};
    this.style = {};
    this.hackSpecialIssue();
  }
  static parseRem(styleObject) {
    let style = {};
    const keys = Object.keys(styleObject);
    if (keys.length) {
      keys.forEach((key) => {
        style[key] = parseRemStyle(styleObject[key]);
      });
    } else {
      style = styleObject;
    }
    return style;
  }
  get component() {
    if (this.tagComponent) {
      return this.tagComponent;
    }
    this.tagComponent = getTagComponent(this.tagName);
    return this.tagComponent;
  }
  isRootNode() {
    const {rootContainer} = getEVOCachedInstance();
    return super.isRootNode() || this.id === rootContainer;
  }
  appendChild(child) {
    super.appendChild(child);
  }
  insertBefore(child, anchor) {
    super.insertBefore(child, anchor);
  }
  moveChild(child, anchor) {
    super.moveChild(child, anchor);
  }
  removeChild(child) {
    super.removeChild(child);
  }
  hasAttribute(key) {
    return !!this.attributes[key];
  }
  getAttribute(key) {
    return this.attributes[key];
  }
  removeAttribute(key) {
    delete this.attributes[key];
  }
  setAttribute(rawKey, rawValue, options = {}) {
    let value = rawValue;
    const key = rawKey;
    try {
      if (typeof this.attributes[key] === "boolean" && value === "") {
        value = true;
      }
      if (key === void 0) {
        !options.notToNative && this.updateNativeNode();
        return;
      }
      switch (key) {
        case "class": {
          const newClassList = new Set(value.split(" ").filter((x) => x.trim()));
          if (setsAreEqual(this.classList, newClassList)) {
            return;
          }
          this.classList = newClassList;
          this.attributes[key] = value;
          !options.notToNative && this.updateNativeNode(true);
          return;
        }
        case "id":
          if (value === this.id) {
            return;
          }
          this.id = value;
          this.attributes.id = value;
          !options.notToNative && this.updateNativeNode(true);
          return;
        case "title":
          this.attributes.tooltip = value;
          !options.notToNative && this.updateNativeNode();
          return;
        case "numberOfLines":
          this.attributes["max-lines"] = `${value}`;
          this.attributes.ellipsize = "end";
          this.attributes["text-overflow"] = "ellipsis";
          !options.notToNative && this.updateNativeNode();
          return;
        case "ellipsizeMode":
          this.attributes["text-overflow"] = value == "tail" ? "ellipsis" : "none";
          !options.notToNative && this.updateNativeNode();
          return;
        case "hidden":
          this.attributes.hidden = "true";
          !options.notToNative && this.updateNativeNode();
          return;
        case "text":
          this.attributes.content = value;
          break;
        default:
          break;
      }
      if (this.attributes[key] === value)
        return;
      this.attributes[key] = value;
      if (typeof this.filterAttribute === "function") {
        this.filterAttribute(this.attributes);
      }
      !options.notToNative && this.updateNativeNode();
    } catch (err) {
      throw err;
    }
  }
  setText(text, options = {}) {
    return this.setAttribute("text", text, {
      notToNative: !!options.notToNative
    });
  }
  removeStyle(notToNative = false) {
    this.style = {};
    if (!notToNative) {
      this.updateNativeNode();
    }
  }
  setStyles(batchStyles) {
    if (!batchStyles || typeof batchStyles !== "object") {
      return;
    }
    Object.keys(batchStyles).forEach((styleKey) => {
      const styleValue = batchStyles[styleKey];
      this.setStyle(styleKey, styleValue, true);
    });
    this.updateNativeNode();
  }
  setStyle(property, value, notToNative = false) {
    if (value === void 0) {
      delete this.style[property];
      if (!notToNative) {
        this.updateNativeNode();
      }
      return;
    }
    let {property: styleProperty, value: styleValue} = this.beforeLoadStyle({
      property,
      value
    });
    switch (styleProperty) {
      case "fontWeight":
        if (typeof styleValue !== "string") {
          styleValue = styleValue.toString();
        }
        break;
      case "textShadowOffsetX":
      case "textShadowOffsetY": {
        [styleProperty, styleValue] = parseTextShadowOffset(styleProperty, styleValue, this.style);
        break;
      }
      case "textShadowOffset": {
        const {x = 0, width = 0, y = 0, height = 0} = styleValue != null ? styleValue : {};
        styleValue = {width: x || width, height: y || height};
        break;
      }
      default: {
      }
    }
    if (styleValue === void 0 || styleValue === null || this.style[styleProperty] === styleValue) {
      return;
    }
    this.style[styleProperty] = styleValue;
    if (!notToNative) {
      this.updateNativeNode();
    }
  }
  scrollToPosition(x = 0, y = 0, rawDuration = 1e3) {
    if (typeof x !== "number" || typeof y !== "number") {
      return;
    }
    let duration = rawDuration;
    if (duration === false) {
      duration = 0;
    }
    const {vnContext: vnContext2} = getEVOCachedInstance();
    const dom = vnContext2.page.getElementByNodeId(this.nodeId);
    dom.scrollToEx(x, y);
  }
  scrollTo(x, y, duration) {
    if (typeof x === "object") {
      const {left, top, behavior = "auto", duration: animationDuration} = x;
      this.scrollToPosition(left, top, behavior === "none" ? 0 : animationDuration);
    } else {
      this.scrollToPosition(x, y, duration);
    }
  }
  addEventListener(rawEventNames, rawCallback, rawOptions) {
    let eventNames = rawEventNames;
    let callback = rawCallback;
    let options = rawOptions;
    if (eventNames === "scroll" && !(this.getAttribute("scrollEventThrottle") > 0)) {
      this.attributes.scrollEventThrottle = 200;
    }
    if (typeof this.polyfillNativeEvents === "function") {
      ({eventNames, callback, options} = this.polyfillNativeEvents(EventMethod.ADD, eventNames, callback, options));
    }
    super.addEventListener(eventNames, callback, options);
    this.updateNativeNode();
  }
  removeEventListener(rawEventNames, rawCallback, rawOptions) {
    let eventNames = rawEventNames;
    let callback = rawCallback;
    let options = rawOptions;
    if (typeof this.polyfillNativeEvents === "function") {
      ({eventNames, callback, options} = this.polyfillNativeEvents(EventMethod.REMOVE, eventNames, callback, options));
    }
    super.removeEventListener(eventNames, callback, options);
    this.updateNativeNode();
  }
  dispatchCaptureEvent(rawEvent) {
    const event = rawEvent;
    event.currentTarget = this;
    if (!event.target) {
      event.target = this;
    }
    if (this.parentNode && !event.isP2P) {
      this.parentNode.dispatchCaptureEvent.call(this.parentNode, event);
    }
    const ret = this.emitCaptureEvent(event);
    return ret;
  }
  dispatchEvent(rawEvent) {
    const event = rawEvent;
    event.currentTarget = this;
    if (!event.target) {
      event.target = this;
    }
    const ret = this.emitEvent(event);
    if (this.parentNode && event.bubbles && !event.isP2P) {
      this.parentNode.dispatchEvent.call(this.parentNode, event);
    }
    return ret;
  }
  convertToNativeNodes(isIncludeChild) {
    if (!this.component) {
      return [];
    }
    if (!this.isNeedInsertToNative) {
      return [];
    }
    if (isIncludeChild) {
      return super.convertToNativeNodes(true);
    }
    let style = this.getNativeStyles();
    if (this.component.defaultNativeStyle) {
      style = __spreadValues(__spreadValues({}, this.component.defaultNativeStyle), style);
    }
    const elementExtraAttributes = {
      name: this.component.name,
      props: __spreadProps(__spreadValues(__spreadValues({}, this.getNativeProps()), this.getNativeEvents()), {
        style
      }),
      tagName: this.tagName
    };
    parseViewComponent(this, elementExtraAttributes, style);
    return super.convertToNativeNodes(false, elementExtraAttributes);
  }
  repaintWithChildren() {
    this.updateNativeNode(true);
  }
  setNativeProps(nativeProps) {
    if (nativeProps) {
      const {style} = nativeProps;
      this.setStyles(style);
    }
  }
  setPressed(pressed) {
  }
  setHotspot(x, y) {
  }
  setStyleScope(scopeStyleId) {
    const scopedId = typeof scopeStyleId !== "string" ? scopeStyleId.toString() : scopeStyleId;
    if (scopedId && !this.scopedIdList.includes(scopedId)) {
      this.scopedIdList.push(scopedId);
    }
  }
  get styleScopeId() {
    return this.scopedIdList;
  }
  getNativeNode() {
    return vnContext.page.getElementByNodeId(this.nodeId);
  }
  getInlineStyle() {
    const nodeStyle = {};
    Object.keys(this.style).forEach((key) => {
      const styleValue = toRaw(this.style[key]);
      if (styleValue !== void 0) {
        nodeStyle[key] = styleValue;
      }
    });
    return nodeStyle;
  }
  getNativeStyles() {
    let style = {};
    style = EVOElement.parseRem(__spreadValues(__spreadValues({}, style), this.getInlineStyle()));
    return style;
  }
  hackNativeProps(rawProps) {
    const props = rawProps;
  }
  getNativeProps() {
    const props = {};
    const {defaultNativeProps} = this.component;
    if (defaultNativeProps) {
      Object.keys(defaultNativeProps).forEach((key) => {
        if (this.getAttribute(key) === void 0) {
          const prop = defaultNativeProps[key];
          props[key] = isFunction(prop) ? prop(this) : prop;
        }
      });
    }
    Object.keys(this.attributes).forEach((key) => {
      var _a;
      let value = toRaw(this.getAttribute(key));
      if (!this.component.attributeMaps || !this.component.attributeMaps[key]) {
        props[key] = value;
        return;
      }
      const map = this.component.attributeMaps[key];
      if (isString(map)) {
        props[map] = value;
        return;
      }
      if (isFunction(map)) {
        props[key] = map(value);
        return;
      }
      const {name: propsKey, propsValue, jointKey} = map;
      if (isFunction(propsValue)) {
        value = propsValue(value);
      }
      if (jointKey) {
        props[jointKey] = (_a = props[jointKey]) != null ? _a : {};
        Object.assign(props[jointKey], {
          [propsKey]: value
        });
      } else {
        props[propsKey] = value;
      }
    });
    const {nativeProps} = this.component;
    if (nativeProps) {
      Object.keys(nativeProps).forEach((key) => {
        props[key] = nativeProps[key];
      });
    }
    this.hackNativeProps(props);
    return props;
  }
  getNodeAttributes() {
    var _a;
    try {
      const nodeAttributes = deepCopy(this.attributes);
      const classInfo = Array.from((_a = this.classList) != null ? _a : []).join(" ");
      const attributes = __spreadValues({
        id: this.id,
        EVONodeId: `${this.nodeId}`,
        class: classInfo
      }, nodeAttributes);
      delete attributes.text;
      delete attributes.value;
      return attributes;
    } catch (error) {
      return {};
    }
  }
  getNativeEvents() {
    const events = {};
    const eventList = this.getEventListenerList();
    const eventKeys = Object.keys(eventList);
    if (eventKeys.length) {
      const {eventNamesMap} = this.component;
      eventKeys.forEach((eventKey) => {
        const nativeEventName = eventNamesMap == null ? void 0 : eventNamesMap.get(eventKey);
        if (nativeEventName) {
          events[nativeEventName] = !!eventList[eventKey];
        } else {
          const name = `on${capitalizeFirstLetter(eventKey)}`;
          events[name] = !!eventList[eventKey];
        }
      });
    }
    return events;
  }
  hackSpecialIssue() {
    this.fixVShowDirectiveIssue();
  }
  fixVShowDirectiveIssue() {
    let display;
    Object.defineProperty(this.style, "display", {
      enumerable: true,
      configurable: true,
      get() {
        return display;
      },
      set: (newValue) => {
        display = newValue === void 0 ? "flex" : newValue;
        this.attributes.hidden = display === "none" ? "true" : "false";
        this.updateNativeNode();
      }
    });
  }
};
var EVOCommentElement = class extends EVOElement {
  constructor(text) {
    super(text);
    this.text = text;
    this.isNeedInsertToNative = false;
  }
};
var EVOTextElement = class extends EVONode {
  constructor(text) {
    super(NodeType.TextNode);
    this.text = text;
  }
  setText(text) {
    this.text = text;
    if (this.parentNode && this.nodeType === NodeType.ElementNode) {
      this.parentNode.setText(text);
    }
  }
};

// runtime/document/evo-document.ts
var depthFirstTraversalRecursive = (element, targerId) => {
  var _a;
  if (!element) {
    return void 0;
  }
  if (((_a = element == null ? void 0 : element.getId) == null ? void 0 : _a.call(element)) === targerId) {
    return element;
  }
  const children = element.getChildElements();
  for (const child of children) {
    const res = depthFirstTraversalRecursive(child, targerId);
    if (res) {
      return res;
    }
  }
};
var depthFirstTraversalRecursiveWithEvoElememt = (element, targerId) => {
  var _a;
  if (((_a = element.attributes) == null ? void 0 : _a.id) === targerId) {
    return element;
  }
  const children = element.childNodes;
  for (const child of children) {
    const res = depthFirstTraversalRecursiveWithEvoElememt(child, targerId);
    if (res) {
      return res;
    }
  }
};
var EVODocument = class extends EVONode {
  static createElement(tagName) {
    switch (tagName) {
      default:
        return new EVOElement(tagName);
    }
  }
  static createComment(text) {
    return new EVOCommentElement(text);
  }
  static createTextNode(text) {
    return new EVOTextElement(text);
  }
  getElementById(targerId) {
    const ele = depthFirstTraversalRecursive(getEVOCachedInstance().vnContext.page.getElementByNodeId(0), targerId);
    return ele ? ele : null;
  }
  getEVOElementById(targerId) {
    const rootEvoElememt = global.$rootEvoElememt;
    const ele = depthFirstTraversalRecursiveWithEvoElememt(rootEvoElememt, targerId);
    return ele ? ele : null;
  }
  getVn() {
    return getEVOCachedInstance().vnContext;
  }
  constructor() {
    super(NodeType.DocumentNode);
  }
};

// node-ops.ts
import {parseDocument} from "htmlparser2";
function insert(child, parent, anchor = null) {
  var _a;
  if (((_a = parent.childNodes) == null ? void 0 : _a.indexOf(child)) >= 0) {
    parent.moveChild(child, anchor);
  } else {
    parent.insertBefore(child, anchor);
  }
}
function remove(child) {
  const parent = child.parentNode;
  if (parent) {
    parent.removeChild(child);
    unCacheNodeOnIdle(child);
  }
}
function createElement(name) {
  return EVODocument.createElement(name);
}
function createText(text) {
  return EVODocument.createTextNode(text);
}
function createComment(text) {
  return EVODocument.createComment(text);
}
function setText(node, text) {
  node.setText(text);
}
function setElementText(element, text) {
  element.setText(text);
}
function parentNode(node) {
  return node.parentNode;
}
function nextSibling(node) {
  return node.nextSibling;
}
function setScopeId(element, id) {
  element.setAttribute(id, "");
}
function insertStaticContent(content, parent, anchor, isSVG, start, end) {
  const before = anchor ? anchor.previousSibling : parent.lastChild;
  const dom = parseDocument(content);
  const divContainer = createElement("div");
  const getEvoElementTree = (dom2, divContainer2) => {
    if (dom2.type === "root" && dom2.children.length > 0) {
      dom2.children.forEach((item) => {
        getEvoElementTree(item, divContainer2);
      });
    }
    if (dom2.type === "tag") {
      const curEle = createElement(dom2.name);
      for (const key in dom2.attribs) {
        if (Object.prototype.hasOwnProperty.call(dom2.attribs, key)) {
          curEle.setAttribute(key, dom2.attribs[key]);
        }
      }
      if (dom2.name === "span" && dom2.children[0]) {
        curEle.setText(dom2.children[0].data);
      } else {
        if (dom2.children.length > 0) {
          dom2.children.forEach((item) => {
            getEvoElementTree(item, curEle);
          });
        }
      }
      divContainer2.appendChild(curEle);
    }
  };
  getEvoElementTree(dom, divContainer);
  while (divContainer.firstChild) {
    parent.insertBefore(divContainer.firstChild, anchor);
  }
  return [
    before ? before.nextSibling : parent.firstChild,
    anchor ? anchor.previousSibling : parent.lastChild
  ];
}
var nodeOps = {
  insert,
  remove,
  setText,
  setElementText,
  createElement,
  createComment,
  createText,
  parentNode,
  nextSibling,
  setScopeId,
  insertStaticContent
};

// built-in-component.ts
var builtInTagComponentList = new Map();
var accessibilityAttrMaps = {
  role: "accessibilityRole",
  "aria-label": "accessibilityLabel",
  "aria-disabled": {
    jointKey: "accessibilityState",
    name: "disabled"
  },
  "aria-selected": {
    jointKey: "accessibilityState",
    name: "selected"
  },
  "aria-checked": {
    jointKey: "accessibilityState",
    name: "checked"
  },
  "aria-busy": {
    jointKey: "accessibilityState",
    name: "busy"
  },
  "aria-expanded": {
    jointKey: "accessibilityState",
    name: "expanded"
  },
  "aria-valuemin": {
    jointKey: "accessibilityValue",
    name: "min"
  },
  "aria-valuemax": {
    jointKey: "accessibilityValue",
    name: "max"
  },
  "aria-valuenow": {
    jointKey: "accessibilityValue",
    name: "now"
  },
  "aria-valuetext": {
    jointKey: "accessibilityValue",
    name: "text"
  }
};
var bindPreix = "bind";
var commonEventMap = [
  [`${bindPreix}attached`, "attached"],
  [`${bindPreix}tap`, "click"],
  [`${bindPreix}mousedown`, "mousedown"],
  [`${bindPreix}mouseup`, "mouseup"],
  [`${bindPreix}mousedown`, "mousedown"],
  [`${bindPreix}mouseout`, "mouseout"],
  [`${bindPreix}mouseleave`, "mouseleave"],
  [`${bindPreix}mouseover`, "mouseover"],
  [`${bindPreix}mousewheel`, "wheel"],
  [`${bindPreix}mousemove`, "mousemove"],
  [`${bindPreix}mouseover`, "mouseenter"],
  [`${bindPreix}keydown`, "keydown"],
  [`${bindPreix}keyup`, "keyup"],
  [`${bindPreix}sizechange`, "resize"],
  [`${bindPreix}input`, "input"],
  [`${bindPreix}change`, "change"],
  [`${bindPreix}load`, "load"],
  [`${bindPreix}error`, "error"]
];
var div = {
  component: {
    name: NATIVE_COMPONENT_MAP.view,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var section = div;
var cell = {
  component: {
    name: NATIVE_COMPONENT_MAP.cell,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var gridlist = {
  component: {
    name: NATIVE_COMPONENT_MAP.gridlist,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      if (["bindquerythisframevisible", "bindquerystoragepanelpaintrect", "bindqueryvisiblepaintrect"].includes(nativeEventName)) {
        event.isP2P = true;
      }
      return event;
    }
  }
};
var ul = {
  component: {
    name: NATIVE_COMPONENT_MAP.ul,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var li = {
  component: {
    name: NATIVE_COMPONENT_MAP.li,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var input = {
  component: {
    name: NATIVE_COMPONENT_MAP.input,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var textarea = {
  component: {
    name: NATIVE_COMPONENT_MAP.textarea,
    eventNamesMap: mapEVOEvent(commonEventMap),
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var scrollview = {
  component: {
    name: NATIVE_COMPONENT_MAP.scrollview,
    eventNamesMap: div.component.eventNamesMap,
    attributeMaps: __spreadValues({}, accessibilityAttrMaps),
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    }
  }
};
var button = {
  component: {
    name: NATIVE_COMPONENT_MAP.view,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData
  }
};
var form = {
  component: {
    name: NATIVE_COMPONENT_MAP.view
  }
};
var img = {
  component: {
    name: NATIVE_COMPONENT_MAP.image,
    eventNamesMap: div.component.eventNamesMap,
    processEventData(evtData, nativeEventParams) {
      const {handler: event, __evt: nativeEventName} = evtData;
      return event;
    },
    defaultNativeStyle: {
      backgroundColor: 0
    },
    attributeMaps: {
      src(value) {
        return value;
      }
    }
  }
};
var span = {
  component: {
    name: NATIVE_COMPONENT_MAP.text,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {
      text: ""
    },
    defaultNativeStyle: {
      color: "#00FFFF"
    }
  }
};
var i = {
  component: {
    name: NATIVE_COMPONENT_MAP.text,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {
      text: ""
    },
    defaultNativeStyle: {
      color: "#00FFFF",
      "font-style": "italic"
    }
  }
};
var em = i;
var richtext2 = {
  component: {
    name: NATIVE_COMPONENT_MAP.richtext2,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {
      text: ""
    },
    defaultNativeStyle: {
      color: "#00FFFF"
    }
  }
};
var qlPlayer = {
  component: {
    name: NATIVE_COMPONENT_MAP.qlPlayer,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {},
    defaultNativeStyle: {}
  }
};
var qlImage = {
  component: {
    name: NATIVE_COMPONENT_MAP.qlImage,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {},
    defaultNativeStyle: {}
  }
};
var qlChannelPlayer = {
  component: {
    name: NATIVE_COMPONENT_MAP.qlChannelPlayer,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData,
    defaultNativeProps: {},
    defaultNativeStyle: {}
  }
};
var qlWebView2 = {
  component: {
    name: NATIVE_COMPONENT_MAP.qlWebView2,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData
  }
};
var qlWebview = {
  component: {
    name: NATIVE_COMPONENT_MAP.qlWebview,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData
  }
};
var vFrame = {
  component: {
    name: NATIVE_COMPONENT_MAP.vFrame,
    attributeMaps: div.component.attributeMaps,
    eventNamesMap: div.component.eventNamesMap,
    processEventData: div.component.processEventData
  }
};
var label = span;
var p = span;
var a = {
  component: __spreadProps(__spreadValues({}, div.component), {
    attributeMaps: {
      href: {
        name: "href",
        propsValue(value) {
          return value;
        }
      }
    }
  })
};
builtInTagComponentList.set("div", div);
builtInTagComponentList.set("section", section);
builtInTagComponentList.set("button", button);
builtInTagComponentList.set("form", form);
builtInTagComponentList.set("img", img);
builtInTagComponentList.set("span", label);
builtInTagComponentList.set("i", i);
builtInTagComponentList.set("em", em);
builtInTagComponentList.set("label", label);
builtInTagComponentList.set("p", p);
builtInTagComponentList.set("scrollview", scrollview);
builtInTagComponentList.set("a", a);
builtInTagComponentList.set("ql-player", qlPlayer);
builtInTagComponentList.set("ql-image", qlImage);
builtInTagComponentList.set("ql-channel-player", qlChannelPlayer);
builtInTagComponentList.set("ul", ul);
builtInTagComponentList.set("li", li);
builtInTagComponentList.set("input", input);
builtInTagComponentList.set("textarea", textarea);
builtInTagComponentList.set("richtext2", richtext2);
builtInTagComponentList.set("ql-web-view2", qlWebView2);
builtInTagComponentList.set("ql-webview", qlWebview);
builtInTagComponentList.set("v-frame", vFrame);
builtInTagComponentList.set("cell", cell);
builtInTagComponentList.set("grid-list", gridlist);
var built_in_component_default = {
  install() {
    builtInTagComponentList.forEach((elementComponent, tagName) => {
      registerElement(tagName, elementComponent);
    });
  }
};

// runtime/event/evo-event.ts
var EVOEvent = class {
  constructor(eventName) {
    this.target = null;
    this.currentTarget = null;
    this.bubbles = true;
    this.isP2P = false;
    this.deltaX = void 0;
    this.deltaY = void 0;
    this.x = void 0;
    this.y = void 0;
    this.cancelable = true;
    this.eventPhase = false;
    this.isCanceled = false;
    this.type = eventName;
    this.timeStamp = Date.now();
  }
  get canceled() {
    return this.isCanceled;
  }
  stopPropagation() {
    var _a;
    this.bubbles = false;
    (_a = this.nativeParams) == null ? void 0 : _a.stopPropagation();
  }
  preventDefault() {
    if (this.cancelable) {
      if (this.isCanceled) {
        return;
      }
      this.isCanceled = true;
    }
  }
};
var EVOP2PEvent = class extends EVOEvent {
  constructor(eventName) {
    super(eventName);
    this.isP2P = true;
  }
};

// runtime/event/evo-event-dispatcher.ts
var componentName2 = ["%c[event]%c", "color: green", "color: auto"];
function getVueEventName(eventName, targetNode) {
  const {eventNamesMap} = targetNode.component;
  if (eventNamesMap == null ? void 0 : eventNamesMap.has(eventName)) {
    return eventNamesMap.get(eventName);
  }
  if (eventName.indexOf("on") !== 0) {
    return eventName;
  }
  const str = eventName.slice(2, eventName.length);
  return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
}
var EVOEventDispatcher = class {
  receiveNativeComponentEvent(e) {
    var _a;
    const eventName = e.type;
    trace(...componentName2, eventName);
    const targetNode = getNodeById(getViewId(e.target));
    if (!targetNode) {
      return;
    }
    let targetEvent;
    let targetEventName = getVueEventName(e.type, targetNode);
    if (eventName === "bindtap") {
      const isRightClick = ((_a = e == null ? void 0 : e.event) == null ? void 0 : _a.flags) === 4096;
      targetEventName = isRightClick ? "contextmenu" : targetEventName;
    }
    if (["resize", "mouseleave", "attached", "bindattached", "binddetached"].includes(targetEventName)) {
      targetEvent = new EVOP2PEvent(targetEventName);
    } else {
      targetEvent = new EVOEvent(targetEventName);
    }
    if (targetEventName === "wheel") {
      targetEvent.deltaX = e.event.offsetStandardX;
      targetEvent.deltaY = e.event.offsetStandardY;
    }
    if (targetEventName === "contextmenu") {
      targetEvent.x = e.event.x;
      targetEvent.y = e.event.y;
    }
    if (targetEventName === "click") {
      targetEvent.x = e.event.x;
      targetEvent.y = e.event.y;
    }
    if (targetEventName === "bindscroll") {
      targetEvent.bubbles = false;
    }
    targetEvent.nativeParams = e;
    const {processEventData} = targetNode.component;
    if (processEventData) {
      processEventData({
        __evt: eventName,
        handler: targetEvent
      }, e);
    }
    targetNode.dispatchCaptureEvent(targetEvent);
    return targetNode.dispatchEvent(targetEvent);
  }
  registEventHandler(page) {
    page.__global_event__ = (e) => this.receiveNativeComponentEvent(e);
  }
};
var globalEventDispatcher = new EVOEventDispatcher();

// plugins/evod/config.ts
var config = {
  enable: true,
  log: false,
  server: "localhost",
  port: 31996,
  hook: {
    page: false,
    js: false,
    vn: false,
    setTimeout: false,
    setInterval: false
  }
};

// plugins/evod/evod-protocol.ts
var version = 2;
function getRoot(plugin, isEvoCoreMode) {
  if (!plugin.root) {
    if (!isEvoCoreMode) {
      plugin.root = plugin.context.dom.getElementRoot();
    } else {
      plugin.root = plugin.context.page.getElementByNodeId(0);
    }
  }
  return plugin.root;
}
function getElementByPath(plugin, path, isEvoCoreMode) {
  var _a;
  if (!(path instanceof Array)) {
    throw new Error("\u8DEF\u5F84\u4E0D\u5408\u6CD5");
  }
  let p2 = getRoot(plugin, isEvoCoreMode);
  for (const i2 of path) {
    const children = ((_a = p2 == null ? void 0 : p2.getChildElements) == null ? void 0 : _a.call(p2)) || [];
    if (children[i2])
      p2 = children[i2];
    else
      throw new Error(`element \u8DEF\u5F84 ${path} \u4E0D\u6B63\u786E, \u53EF\u80FD VNML \u5DF2\u7ECF\u66F4\u65B0`);
  }
  return p2;
}
function getTargetSerachPath(el) {
  const path = [];
  while (el) {
    path.push(el.__viewId__);
    el = el.getParentElement();
  }
  return path;
}
var filterKeys = [
  "dt-reusable-identifier",
  "element-end-exposure-policy",
  "element-exposure-policy",
  "element-interact-policy",
  "force-last-click-element",
  "element-end-exposure-policy",
  "not-create-page-flag"
];
function recursiveGetElInfo(el, path, isEvoCoreMode) {
  var _a, _b, _c;
  const props = [];
  const keys = (_a = el.getPropertyKeyList) == null ? void 0 : _a.call(el);
  if (keys) {
    for (const key of keys) {
      if (filterKeys.includes(key)) {
        continue;
      }
      if (el.getType() === "text" && key === "text") {
        continue;
      }
      if (key !== "" && key.indexOf("bind") !== 0 && key.indexOf("data-v") !== 0) {
        const value = el.getProperty(key);
        if ((value == null ? void 0 : value.length) > 0) {
          props.push({key, value});
        }
      }
    }
  }
  return {
    viewId: el.__viewId__,
    forceUnFold: false,
    name: el.getType(),
    props,
    children: ((_c = (_b = el == null ? void 0 : el.getChildElements) == null ? void 0 : _b.call(el)) == null ? void 0 : _c.map((el2, index) => recursiveGetElInfo(el2, [...path, index], isEvoCoreMode))) || [],
    path
  };
}
function onServerError(error) {
  config.log && console.log(`VN Debugger error: ${error}`);
}
var server = {
  updateVNML(plugin) {
    try {
      plugin.request("update-VNML", {
        el: recursiveGetElInfo(getRoot(plugin, plugin.isEvoCoreMode), [], plugin.isEvoCoreMode)
      }, (data) => {
        if (data.error) {
          onServerError(data.error);
          plugin.clientAutoOperationManager.setOperationOn("autoUpdateVNML", false);
          return;
        }
      });
    } catch (error) {
      console.log(error);
      plugin.clientAutoOperationManager.setOperationOn("autoUpdateVNML", false);
      plugin.request("update-VNML", {
        el: {
          name: "\u5982\u679C\u770B\u5230\u8FD9\u4E2A\u9519\u8BEF, \u68C0\u67E5 VN \u5185\u6838\u662F\u5426\u65E0\u6CD5\u83B7\u53D6\u6839\u8282\u70B9",
          props: {},
          children: [],
          path: ""
        }
      }, (data) => {
        if (data.error) {
          onServerError(data.error);
          plugin.clientAutoOperationManager.setOperationOn("autoUpdateVNML", false);
          return;
        }
      });
    }
  },
  focusViewOnDebugger(plugin, el) {
    try {
      plugin.request("focusView", {
        searchPath: getTargetSerachPath(el)
      }, (data) => {
        if (data.error) {
          onServerError(data.error);
          return;
        }
      });
    } catch (error) {
      console.log(error);
    }
  },
  updateData(plugin) {
    const datas = [];
    for (const name of plugin.watch)
      datas.push({name, value: plugin.context.data.query(name)});
    plugin.request("update-data", {datas}, (data) => {
      if (data.error) {
        onServerError(data.error);
        plugin.clientAutoOperationManager.setOperationOn("autoUpdateData", false);
        return;
      }
    });
  },
  removeData(plugin, name) {
    plugin.request("remove-data", {name}, (data) => {
      if (data.error) {
        onServerError(data.error);
        return;
      }
    });
  },
  onNativeCall(plugin, name, args) {
    plugin.request("on-native-call", {name, args}, (data) => {
      if (data.error) {
        onServerError(data.error);
        return;
      }
    });
  }
};
var client = {
  ["eval"](plugin, isEvoCoreMode, data) {
    try {
      return {result: `${(0, eval)(data.content)}`};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["set-auto-update-VNML"](plugin, isEvoCoreMode, data) {
    try {
      plugin.clientAutoOperationManager.setOperationOn("autoUpdateVNML", data.value);
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["set-auto-update-data"](plugin, isEvoCoreMode, data) {
    try {
      plugin.clientAutoOperationManager.setOperationOn("autoUpdateData", data.value);
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["el-set-property"](plugin, isEvoCoreMode, data) {
    try {
      const el = getElementByPath(plugin, data.path, isEvoCoreMode);
      el.setProperty(data.key, data.value);
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["watch-data"](plugin, isEvoCoreMode, data) {
    try {
      if (data.watch) {
        plugin.watch.add(data.name);
      } else {
        plugin.watch.delete(data.name);
        server.removeData(plugin, data.name);
      }
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["modify-data"](plugin, isEvoCoreMode, data) {
    try {
      if (plugin.context.data.query(data.name) !== void 0) {
        plugin.context.data.update(data.name, data.value);
      } else {
        plugin.context.data.insert(data.name, data.value);
      }
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["delete-data"](plugin, isEvoCoreMode, data) {
    try {
      if (plugin.context.data.query(data.name) !== void 0) {
        plugin.context.data.delete(data.name);
      }
      return {};
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["watch-native-call"](plugin, isEvoCoreMode, data) {
    try {
      if (data.watch) {
        plugin.watchNativeCall.add(data.name);
      } else {
        plugin.watchNativeCall.delete(data.name);
      }
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["fetchComputedPropertiesForDebugger"](plugin, isEvoCoreMode, data) {
    try {
      const props = plugin.fetchComputedPropertiesForDebugger(data.id);
      plugin.request("updateComputedProperties", {props}, (data2) => {
        if (data2.error) {
          onServerError(data2.error);
          return;
        }
      });
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["updateProperty"](plugin, isEvoCoreMode, data) {
    try {
      plugin.updateProperty(data);
      this.fetchComputedPropertiesForDebugger(plugin, isEvoCoreMode, data);
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["deleteProperty"](plugin, isEvoCoreMode, data) {
    try {
      plugin.deleteProperty(data);
      this.fetchComputedPropertiesForDebugger(plugin, isEvoCoreMode, data);
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["hoverItem"](plugin, isEvoCoreMode, data) {
    try {
      plugin.hoverItemForDebugger(data.id);
    } catch (e) {
      return {error: `${e}`};
    }
  },
  ["unhoverItem"](plugin, isEvoCoreMode, data) {
    try {
      plugin.unhoverItemForDebugger(data.id);
    } catch (e) {
      return {error: `${e}`};
    }
  }
};
var ClientAutoOperationManager = class {
  constructor(context, plugin, isEvoCoreMode) {
    this.context = context;
    this.plugin = plugin;
    this.isEvoCoreMode = isEvoCoreMode;
    this.opeartions = new Map();
    this.opeartions.set("autoUpdateVNML", {
      isDefaultOn: false,
      isOn: false,
      do: () => server.updateVNML(plugin)
    });
    this.opeartions.set("autoUpdateData", {
      isDefaultOn: false,
      isOn: false,
      do: () => server.updateData(plugin)
    });
  }
  dispose() {
    const clearIntervalFunc = this.context.clearInterval ? this.context.clearInterval : clearVNInterval;
    clearIntervalFunc(this.intervalTimer);
  }
  runAutoTasks() {
    const setIntervalFunc = this.context.setInterval ? this.context.setInterval : setVNInterval;
    this.intervalTimer = setIntervalFunc(() => {
      this.opeartions.forEach((op) => {
        if (op.isOn) {
          op.do(this.plugin);
        }
      });
    }, 100);
  }
  setOperationOn(type, isOn2) {
    const operation = this.opeartions.get(type);
    if (operation) {
      operation.isOn = isOn2;
    }
  }
};
function getDirectionName() {
  const path = __dirname.replace(/\\/g, "/").replace(/^[a-zA-Z]:\//, "").split("/");
  while (path.length) {
    const part = path.pop();
    if (part === "index")
      continue;
    return part;
  }
  return "\u672A\u547D\u540D";
}
function getPageName() {
  if (global.PAGE_NAME) {
    return global.PAGE_NAME;
  }
  return getDirectionName();
}

// plugins/evod/evod-plugin.ts
import {
  createConnection
} from "net";
function randomString(length = 32, ...excludes) {
  while (true) {
    let result = "";
    while (result.length < length) {
      result += Math.random().toString(36).slice(2);
    }
    result = result.slice(0, length);
    if (excludes.includes(result)) {
      continue;
    }
    return result;
  }
}
var EVODebugPlugin = class {
  constructor(context, isEvoCoreMode) {
    this.connection = null;
    this.send = null;
    this.stop = false;
    this.watch = new Set();
    this.watchNativeCall = new Set();
    this.sessions = new Map();
    this.root = null;
    this.connectionEndTimeoutTimer = null;
    this.isEvoCoreMode = false;
    this.clientAutoOperationManager = null;
    this.context = context;
    this.isEvoCoreMode = isEvoCoreMode;
  }
  getContextUniqueId() {
    if (!this.isEvoCoreMode) {
      if (!this.isComponent()) {
        return this.context.page.getContextUniqueId();
      }
      return this.context.dom.getElementRoot().getContextUniqueId();
    }
    return this.context.page.getContextUniqueId();
  }
  isComponent() {
    return this.context.isComponent;
  }
  getPath(context) {
    var _a, _b;
    const componentId = context.isComponent ? (_b = (_a = context.componentRoot) == null ? void 0 : _a.getProperty) == null ? void 0 : _b.call(_a, "component-id") : getPageName();
    if (context.parent) {
      return `${this.getPath(context.parent)}/${componentId}`;
    }
    return componentId;
  }
  onConnected(context) {
    if (!this.isEvoCoreMode) {
      if (!this.isComponent()) {
        return {
          name: `${this.getPath(context)} <${context.type}>`,
          id: context.page.getContextUniqueId()
        };
      }
      return {
        name: `${this.getPath(context)} <${context.type}>`,
        id: context.dom.getElementRoot().getContextUniqueId()
      };
    }
    return {
      name: context.page.getPageName(),
      id: context.page.getContextUniqueId()
    };
  }
  focusViewOnDebugger(e) {
    console.log(`focusViewOnDebugger id=${e.__viewId__}`);
    server.focusViewOnDebugger(this, e);
  }
  fetchComputedPropertiesForDebugger(id) {
    return this.context.page.fetchComputedPropertiesForDebugger(id);
  }
  updateProperty(data) {
    const {id} = data;
    const dom = this.context.page.getElementByNodeId(id);
    if (!dom) {
      return;
    }
    Object.entries(data.data).forEach(([key, value]) => {
      dom.setProperty(key, value);
    });
  }
  deleteProperty(data) {
    const {id} = data;
    const dom = this.context.page.getElementByNodeId(id);
    if (!dom) {
      return;
    }
    dom.deleteProperty(data.data.key);
  }
  hoverItemForDebugger(id) {
    return this.context.page.hoverItemForDebugger(id);
  }
  unhoverItemForDebugger(id) {
    return this.context.page.unhoverItemForDebugger(id);
  }
  onReady(page) {
    const focusViewOnDebuggerCaptureThis = (e) => this.focusViewOnDebugger(e);
    page.focusViewOnDebugger = (e) => {
      focusViewOnDebuggerCaptureThis(e);
    };
    const {update} = this.context.data;
    this.context.data.update = (keyPath, data) => {
      if (keyPath) {
        const name = keyPath.split("[")[0].split(".")[0];
        if (name) {
          this.watch.add(name);
        }
      }
      return update(keyPath, data);
    };
    this.connect();
    this.clientAutoOperationManager = new ClientAutoOperationManager(this.context, this, this.isEvoCoreMode);
    this.clientAutoOperationManager.runAutoTasks();
  }
  onUnload() {
    this.stop = true;
    if (this.connection) {
      this.connection.end();
    }
    const clearTimeoutFunc = this.context.clearTimeout ? this.context.clearTimeout : clearVNTimeout;
    this.clientAutoOperationManager.dispose();
    clearTimeoutFunc(this.connectionEndTimeoutTimer);
  }
  connect() {
    if (this.stop) {
      return;
    }
    config.log && console.log(`connect to ${config.server}:${config.port}...`);
    this.connection = createConnection(config.port, config.server, () => {
      console.log("\u{1F680} ~ EVODebugPlugin ~ this.connection=net.createConnection ~ createConnection:");
      config.log && console.log("connected");
      this.send = (data) => {
        this.connection.write(data);
      };
      this.connection.write(`${JSON.stringify(this.onConnected(this.context))}\0`);
    });
    this.connection.on("error", (e) => {
      config.log && console.log(e);
      const setTimeoutFunc = this.context.setTimeout ? this.context.setTimeout : setVNTimeout;
      this.connectionEndTimeoutTimer = setTimeoutFunc(() => {
        this.connect();
      }, 1e3);
    });
    this.connection.on("close", (e) => {
      config.log && console.log("close connection:%s", e);
      this.connection = null;
      this.send = null;
    });
    const datas = [];
    this.connection.on("data", (data) => {
      while (true) {
        data = Buffer.concat(datas.concat(data));
        datas.length = 0;
        const idx = data.findIndex((value) => value === 0);
        if (idx !== -1) {
          try {
            this.onData(data.slice(0, idx));
          } catch (e) {
            config.log && console.log(e);
          }
          data = data.slice(idx + 1);
        } else {
          if (data.length)
            datas.push(data);
          break;
        }
      }
    });
  }
  onData(data) {
    const json = JSON.parse(data.toString());
    if (json.command) {
      if (json.command in client) {
        this.response(json.session, client[json.command](this, this.isEvoCoreMode, json.data));
      } else {
        this.response(json.session, {error: `unknown command ${json.command} (protocol version: ${version})`});
      }
    } else {
      if (this.sessions.has(json.session)) {
        this.sessions.get(json.session)(json.data);
        this.sessions.delete(json.session);
      }
    }
  }
  request(command, data, onFinished) {
    if (this.send) {
      let session = null;
      const clientId = this.getContextUniqueId();
      do
        session = randomString();
      while (this.sessions.has(session));
      this.sessions.set(session, onFinished);
      this.send(`${JSON.stringify({
        session,
        data,
        command,
        clientId
      })}\0`);
    }
  }
  response(session, data) {
    if (this.send) {
      this.send(`${JSON.stringify({
        session,
        data
      })}\0`);
    }
  }
};

// index.ts
function createRootNode(rootContainer) {
  const root = EVODocument.createElement("div");
  root.setAttribute("id", rootContainer);
  root.setAttribute("flex-grow", "1");
  root.setAttribute("flex-shrink", "0");
  return root;
}
var createApp = (vueRootComponent, options) => {
  const customRender = createRenderer(__spreadValues({
    patchProp
  }, nodeOps));
  global.evoDocument = new EVODocument();
  const app = customRender.createApp(vueRootComponent, options);
  const evoApp = app;
  evoApp.use(built_in_component_default);
  const {mount} = evoApp;
  evoApp.mount = (rootContainer) => {
    const root = createRootNode(rootContainer);
    global.$rootEvoElememt = root;
    getEVOCachedInstance().rootContainer = rootContainer;
    const instance = mount(root, false, false);
    return instance;
  };
  evoApp.mountToEle = (ele) => {
    const instance = mount(ele, false, false);
    return instance;
  };
  app.onReady = (vnContext2, rootContainerDom, page) => {
    const rootViewId = getViewId(rootContainerDom);
    const oldInstance = getEVOCachedInstance();
    if (oldInstance == null ? void 0 : oldInstance.app) {
      oldInstance.app.unmount();
    }
    global.vnContext = vnContext2;
    global.setTimeout = setVNTimeout;
    global.clearTimeout = clearVNTimeout;
    global.setInterval = setVNInterval;
    global.clearInterval = clearVNInterval;
    global.page = page;
    global.renderToNativeImmediate = renderToNativeImmediate;
    setEVOCachedInstance({
      rootViewId,
      vnContext: vnContext2,
      app: evoApp
    });
    if (__DEBUG__DOM__) {
      const eVODebugPlugin = new EVODebugPlugin(vnContext2, true);
      eVODebugPlugin.onReady(page);
    }
    globalEventDispatcher.registEventHandler(page);
  };
  return evoApp;
};
export {
  createApp
};
